import { RepositorioBase } from "@/http"
import {
  TravarPeriodo,
  DestravarPeriodo,
  ListarControlador,
  VisualizarControladores,
} from "./travamento.modelo"
import { ResultadoApiGET } from "@/types/api"

export class TravamentosRepositorio extends RepositorioBase {
  public travarPeriodo = (params?: TravarPeriodo): Promise<{ id: string }> =>
    this.instance.post("/api/travamentos/travar", params)

  public destravarPeriodo = (
    params?: DestravarPeriodo
  ): Promise<{ id: string }> =>
    this.instance.post("/api/travamentos/destravar", params)

  public visualizarControladores = (
    params: VisualizarControladores
  ): Promise<ResultadoApiGET<ListarControlador>> =>
    this.instance.get("/api/travamentos", { params })
}
